module.exports = __webpack_public_path__ + "03_glasses_brown.62d9b4a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer4/03_glasses_brown.png
// module id = jbMP
// module chunks = 0